import { withInstall } from '@jdesign-vue/utils'

import PageHeader from './src/page-header.vue'

export const JdPageHeader = withInstall(PageHeader)
export default JdPageHeader

export * from './src/page-header'
